import { InterventionResponse, UpdateInterventionRequest } from './intervention.model';

// The request that saves a case. The save takes the whole case, so each screen sends the case as it is with only what it edits changed.
export function toUpdateRequest(item: InterventionResponse, changes: Partial<UpdateInterventionRequest>): UpdateInterventionRequest {
  return {
    interventionNumber: item.interventionNumber,
    interventionTypeId: item.interventionTypeId,
    interventionName: item.interventionName,
    description: item.description,
    reason: item.reason,
    sourceChannelId: item.sourceChannelId,
    requestTypeId: item.requestTypeId,
    userTypeId: item.userTypeId,
    priorityId: item.priorityId,
    riskClassificationId: item.riskClassificationId,
    confidentialityLevelId: item.confidentialityLevelId,
    status: item.status,
    startDate: item.startDate,
    targetReviewDate: item.targetReviewDate,
    ownerType: item.ownerType,
    otherOwnerType: item.otherOwnerType,
    ownerEmployeeId: item.ownerEmployeeId,
    ownerDependantId: item.ownerDependantId,
    currentOwnerPractitionerId: item.currentOwnerPractitionerId,
    closureDate: item.closureDate,
    closureReason: item.closureReason,
    closureOutcomeId: item.closureOutcomeId,
    ...changes,
  };
}
